import { NavLink } from 'react-router-dom';
import { LayoutDashboard, List, Server, BarChart3, FileCode } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  {
    to: '/',
    label: 'Dashboard',
    icon: LayoutDashboard,
  },
  {
    to: '/jobs',
    label: 'Jobs',
    icon: List,
  },
  {
    to: '/workers',
    label: 'Workers',
    icon: Server,
  },
  {
    to: '/workflows',
    label: 'Workflows',
    icon: FileCode,
  },
  {
    to: '/metrics',
    label: 'Metrics',
    icon: BarChart3,
  },
];

export default function Navigation() {
  return (
    <nav className="border-b border-border bg-background">
      <div className="px-8">
        <div className="flex gap-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 px-4 py-3 border-b-2 transition-colors',
                    'hover:text-foreground hover:border-primary/50',
                    isActive
                      ? 'border-primary text-foreground font-medium'
                      : 'border-transparent text-muted-foreground'
                  )
                }
              >
                <Icon className="h-4 w-4" />
                <span className="text-sm">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
